import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PublishPosterProps} from '@Panels/publish-poster-panel/publish-poster-panel';

export const openPublishPosterModal = (props: PublishPosterProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PUBLISH_POSTER_MODAL,
      panelProps: props,
    })
  );
};
